import { useMemo } from 'react'

import { DatePicker, Menu } from 'antd'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { faCalendar } from '@fortawesome/pro-solid-svg-icons'

import { EUROPEAN_DATE } from '../../../../utils/constants'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import IconLabel, { FontSizes } from '../../../../Components/icons/IconLabel'
import FilterButton from '../../../../Components/antd/Buttons/FilterButton'

export const DEFAULT_FILTERS = {
  period: {
    startDate: moment().startOf('month'),
    endDate: moment().add(12, 'month').endOf('month')
  }
}

const BadgeFilters = ({ filters, onFiltersChange }) => {
  const t = useSelector(selectTranslate)

  const activeFilters = useMemo(() => {
    let count = 0

    if (filters?.period?.startDate || filters?.period?.endDate) {
      count += 1
    }

    return count
  }, [filters])

  const handleFiltersChange = (key, value) => {
    const newFilters = { ...filters, [key]: value }

    onFiltersChange(newFilters)
  }

  return (
    <FilterButton filterCount={activeFilters} onReset={() => onFiltersChange(DEFAULT_FILTERS)}>
      <Menu inlineIndent={10} style={{ width: '200px' }}>
        <Menu.ItemGroup title={<IconLabel fontSize={FontSizes.SMALL} padding={0} icon={faCalendar} text={t('common.period')} />}>
          <Menu.Item key='state' disabled style={{ cursor: 'default' }}>
            <DatePicker.RangePicker
              value={[moment(filters.period.startDate), moment(filters.period.endDate)]}
              format={EUROPEAN_DATE}
              onChange={dates => handleFiltersChange('period', { startDate: dates[0], endDate: dates[1] })}
            />
          </Menu.Item>
        </Menu.ItemGroup>
      </Menu>
    </FilterButton>
  )
}

export default BadgeFilters
